import React from "react";

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="logoShield" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#2a3d52" />
          <stop offset="100%" stopColor="#1a2332" />
        </linearGradient>
        <linearGradient id="logoFuel" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#f5a040" stopOpacity="0.15" />
          <stop offset="100%" stopColor="#e8751a" stopOpacity="0.9" />
        </linearGradient>
        <clipPath id="logoTankClip">
          <rect x="44" y="76" width="112" height="58" rx="29" />
        </clipPath>
      </defs>

      {/* Shield */}
      <path
        d="M 100 6 L 185 38 L 185 110 C 185 155 145 188 100 200 C 55 188 15 155 15 110 L 15 38 Z"
        fill="url(#logoShield)"
        stroke="#e8751a"
        strokeWidth="3"
      />
      <path
        d="M 100 18 L 174 46 L 174 108 C 174 148 139 178 100 189 C 61 178 26 148 26 108 L 26 46 Z"
        fill="none"
        stroke="#e8751a"
        strokeWidth="1"
        opacity="0.25"
      />

      {/* Ground line */}
      <line x1="35" y1="70" x2="165" y2="70" stroke="white" strokeWidth="0.6" opacity="0.15" strokeDasharray="4 3" />

      {/* Tank outline */}
      <rect x="44" y="76" width="112" height="58" rx="29" fill="none" stroke="#e8751a" strokeWidth="2.5" />

      {/* Fuel fill */}
      <rect x="44" y="101" width="112" height="33" clipPath="url(#logoTankClip)" fill="url(#logoFuel)" />

      {/* Fuel surface wave */}
      <path
        d="M 44 101 Q 72 94 100 101 Q 128 108 156 101"
        stroke="#e8751a"
        strokeWidth="1.5"
        opacity="0.6"
        fill="none"
        clipPath="url(#logoTankClip)"
      />

      {/* Fill caps — minimal stubs */}
      <line x1="76" y1="74" x2="76" y2="76" stroke="#e8751a" strokeWidth="2" />
      <line x1="124" y1="74" x2="124" y2="76" stroke="#e8751a" strokeWidth="2" />
      <rect x="69" y="68" width="14" height="8" rx="2" fill="#e8751a" />
      <rect x="117" y="68" width="14" height="8" rx="2" fill="#e8751a" />

      {/* Soil dots */}
      <circle cx="50" cy="150" r="1" fill="white" opacity="0.1" />
      <circle cx="80" cy="157" r="1" fill="white" opacity="0.08" />
      <circle cx="120" cy="153" r="1" fill="white" opacity="0.1" />
      <circle cx="150" cy="150" r="1" fill="white" opacity="0.08" />
    </svg>
  );
};

export default Logo;
